import React, { useState } from 'react';
import { BasicPageContainer } from "components/views/BasicPageContainer";
import { Box, TextField, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useVerifyMfa } from 'hooks/useVerifyMfa';
import { LoadingButton } from '@mui/lab';
import { useTranslation } from 'react-i18next';

export const MfaPage = () => {
    const [code, setCode] = useState('');
    const { verifyMfa, verifyingMfa } = useVerifyMfa();
    const [searchParams] = useSearchParams();
    const mfaId = searchParams.get('mfaId') || undefined;
    const { t } = useTranslation();

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (!mfaId || !code) {
            return;
        }
        verifyMfa({ mfaId, mfaCode: code });
    };

    return (
        <BasicPageContainer>
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                minHeight="60vh"
                gap={2}
                component="form"
                onSubmit={handleSubmit}
            >
                <Typography variant="h5" mb={2}>
                    {t('mfaPage.multiFactorAuthentication')}
                </Typography>
                <Typography variant="body1" mb={2} color="textSecondary" align="center">
                    {t('mfaPage.weHaveSentACode')}
                </Typography>
                <TextField
                    label={t('mfaPage.verificationCode')}
                    value={code}
                    onChange={e => {
                        const value = e.target.value.replace(/[^0-9a-zA-Z]/g, '').slice(0, 6);
                        setCode(value);
                    }}
                    variant="outlined"
                    required
                    autoFocus
                    inputProps={{ maxLength: 6, pattern: ".{6,6}" }}
                    helperText={t('mfaPage.enterYourCode')}
                    error={code.length > 0 && code.length < 6}
                />
                <LoadingButton
                    loading={verifyingMfa}
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={!mfaId || code.length !== 6}
                >
                    {t('mfaPage.verifyCode')}
                </LoadingButton>
                {!mfaId && (
                    <Typography color="error" mt={2}>
                        {t('mfaPage.mfaLinkInvalidError')}
                    </Typography>
                )}
            </Box>
        </BasicPageContainer>
    );
};